import { BASE_URL } from 'src/components/10-atoms/seo/constants';
export function getEPHomeCanonical(examLevelID, tabID) {
    const params = new URLSearchParams();
    if (examLevelID) {
        params.set('examLevelID', examLevelID);
    }
    if (tabID) {
        params.set('tabID', tabID);
    }
    const query = params.toString();
    return query ? `exam-prep/home?${query}` : 'exam-prep/home';
}
export function getEPHomeUrl(examLevelID) {
    return `${BASE_URL}/${getEPHomeCanonical(examLevelID)}`;
}
